<template>
    <div>
        <div class="primary callout text-center" :class="wrapperClass">
            <p v-html="message"></p>
            <p>
                <span v-if="available">
                    <span
                        class="button"
                        v-if="!processing"
                        @click="proceed"
                    >PROCEED WITH BOOKING</span>
                    <span class="disabled button" v-else>
                        <i class="fas fa-spinner fa-spin"></i> PROCESSING
                    </span>
                </span>
                <span class="secondary button" @click="toggle">
                    <span v-html="expandLabel"></span>
                </span>
            </p>
        </div>
        <availability-calendar
            v-if="expanded"
            :dates="dates"
            :searched="searched"
        ></availability-calendar>
    </div>
</template>
<script>
    import Processing from '../../mixins/Processing';
    import AjaxCaller from '../../mixins/AjaxCaller';
    import AvailabilityCalendar from './Availability';
    export default {
        name: 'SearchResult',
        components: { AvailabilityCalendar },
        mixins: [Processing, AjaxCaller],
        props: {
            available: {
                type: Boolean,
                default: false
            },
            dates: {
                type: Array,
                default: () => []
            },
            searched: {
                type: Array,
                default: () => []
            },
            from: {
                type: String,
                required: true
            },
            to: {
                type: String,
                required: true
            },
            guests: {
                type: Number,
                default: 2
            }
        },
        data() {
            return {
                expanded: false
            }
        },
        computed: {
            expandLabel() {
                return this.expanded ?
                    '<i class="fas fa-angle-up"></i> HIDE CALENDAR' :
                    '<i class="fas fa-angle-down"></i> SEE CALENDAR';
            },
            message() {
                return this.available ?
                    'Good news - we have availability on your chosen dates!' :
                    'Unfortunately - we do not have availability on your chosen dates!';
            },
            wrapperClass() {
                return [this.available ? 'primary' : 'alert' ];
            }
        },
        methods: {
            toggle() {
                this.expanded = !this.expanded;
            },
            proceed() {
                this.startCall();
                this.makeRequest(this.success, this.failure, {}, '/booking/'+this.from+'/'+this.to+'/'+this.guests);
            },
            success() {
                window.location.href = '/booking/address';
            },
            failure(error) {
                this.endCall();
                this.displayError(error.message);
            },
            displayError(message) {
                window.EventHandler.fire('top-warning', {
                    id: 'booking-warning',
                    message: message
                });
            }
        }
    }
</script>